import { FormGroupStatus } from 'src/core/constants/form/form-group-status.constant';
import { ValidationMessageService } from 'src/core/services/validation/validation-message.service';
import { FormBuilder } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { EnumSelectionConfigurationModel } from '../models/enum-selection-configuration.model';
import { EnumSelectionType } from '../models/enum-selection-type.enum';

@Component({
  selector: 'ca-enum-selection-panel',
  templateUrl: './enum-selection-panel.component.html',
  styleUrls: ['./enum-selection-panel.component.scss'],
  standalone: false,
})
export class EnumSelectionPanelComponent extends FilterPanelEditorComponent implements OnInit {
  items: { id: number; name: string }[] = [];
  selectionType = EnumSelectionType;
  errorMessage: string[] = [];
  randomKey: string;
  actualConfig: EnumSelectionConfigurationModel;

  _value: any;

  @Input()
  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as EnumSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  get value(): any {
    if (
      this._value &&
      this._value.length &&
      this.actualConfig &&
      this.actualConfig.valuesToExclude
    ) {
      this._value = this._value.filter(v => !this.actualConfig.valuesToExclude.includes(v));
    }
    return this._value;
  }

  set value(value: any) {
    if (value && value.length && this.actualConfig && this.actualConfig.valuesToExclude) {
      value = value.filter(v => !this.actualConfig.valuesToExclude.includes(v));
    }
    this._value = value;

    this.editorForm.patchValue({
      editor: this.value,
    });
  }

  get labelClass() {
    let cls = '';
    if (this.actualConfig.inlineCls) {
      cls = this.actualConfig.inlineCls;
    }
    return cls;
  }

  getEnumValues(enumObj: any) {
    return Object.keys(enumObj)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        id: enumObj[key],
        name: key.replace(/([A-Z])/g, ' $1').trim(),
      }));
  }

  init(): void {
    super.init();
    this.loadEnumItems();
  }

  loadEnumItems() {
    const enumObj = this.actualConfig.enumType;
    if (!enumObj) return;

    let list = Object.keys(enumObj)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        id: enumObj[key],
        name: this.actualConfig.customLabels?.[enumObj[key]] || key,
      }));

    if (this.actualConfig.valuesToExclude) {
      list = list.filter(item => !this.actualConfig.valuesToExclude.includes(item.id));
    }

    if (this.actualConfig.itemOrder) {
      list.sort((a, b) => {
        const ai = this.actualConfig.itemOrder.indexOf(a.id);
        const bi = this.actualConfig.itemOrder.indexOf(b.id);
        return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
      });
    }

    this.items = list;
  }

  isVisible(item: { id: number; name: string }): boolean {
    if (!this.actualConfig.valuesToExclude || this.actualConfig.valuesToExclude.length === 0) {
      return true;
    }
    return !this.actualConfig.valuesToExclude.includes(item.id);
  }

  reload(): void {}

  reset(): void {}

  autoSelectFirstItem(): void {}

  onCheckChanged(eventArgs) {
    if (
      this.actualConfig.type == this.selectionType.Combobox &&
      this.actualConfig.multiple === true
    ) {
      this.value = [];
      if (eventArgs.length > 0) {
        this.value = eventArgs;
      }
    } else if (this.actualConfig.type == this.selectionType.Radio) {
      const val = Number(eventArgs.currentTarget.value);

      this.value = [val];
    } else {
      const val = Number(eventArgs.currentTarget.value);
      const checked = eventArgs.currentTarget.checked;
      const idx = this.value.indexOf(val);

      if (checked) {
        if (idx < 0) {
          this.value.push(val);
        }
      } else {
        if (idx > -1) {
          this.value.splice(idx, 1);
        }
      }
    }

    this.editorForm.patchValue({
      editor: this.value,
    });

    this.onChange();
  }

  onSelectChange(eventArgs) {
    const val = Number(eventArgs);

    if (this.value !== val) {
      this.value = val;

      this.onChange();
    }
  }

  constructor(
    protected fb: FormBuilder,
    private validationMessageService: ValidationMessageService,
  ) {
    super(fb);
    this.editorForm.statusChanges.subscribe(x => {
      if (x === FormGroupStatus.INVALID) {
        for (const error in this.editorForm.controls.editor.errors) {
          if (this.editorForm.controls.editor.errors.hasOwnProperty(error)) {
            const errorMessage = this.validationMessageService[error];
            this.errorMessage.push(errorMessage);
          }
        }
      } else {
        this.errorMessage = [];
      }
    });

    this.randomKey = new Date().valueOf().toString();
  }

  ngOnInit(): void {}
}
